import { Injectable } from '@angular/core';

import { setInitialStoreState } from '../../../../../common';
import { DeliveryNoteHandlingUnitsFacade } from './delivery-note-handling-units/delivery-note-handling-units.facade';

@Injectable({
  providedIn: 'root',
})
export class DeliveryNoteOverviewGuard  {
  constructor(private deliveryNoteHandlingUnitsFacade: DeliveryNoteHandlingUnitsFacade) {}

  canDeactivate(): boolean {
    return setInitialStoreState(this.deliveryNoteHandlingUnitsFacade);
  }
}
